import useMediaByValue from "hooks/useMediaByValue";
import { IDepositInfo } from "interfaces/stats";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { formatDateDDMMYYYY } from "utils/formateDate";

interface IDepositStatsProps {
  depositsArr: IDepositInfo[];
}

const DepositStats = ({ depositsArr }: IDepositStatsProps) => {
  const { t } = useTranslation();
  const isMediumeViewPort = useMediaByValue("(min-width:1030px)");
  const isLargeViewPort = useMediaByValue("(min-width:1400px)");

  const totalWeeklyDepositsAmount = depositsArr.reduce((sum: number, deposit) => sum + deposit.amount, 0).toFixed(2);

  return (
    <Grid size={isLargeViewPort ? 4 : isMediumeViewPort ? 6 : 12} sx={{ padding: "26px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
        <Box
          sx={{
            width: "26px",
            height: "26px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(86, 202, 0, 0.16)",
          }}
        >
          <AttachMoneyIcon sx={{ width: "16px", height: "16px", fill: "#56CA00" }} />
        </Box>
        <Typography
          sx={{
            color: "#6D6777",
            fontFamily: "var(--cygreRegular), sans-serif",
            fontWeight: "500",
            fontSize: "15px",
          }}
        >
          {t("deposits")}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: "#2E263D",
          fontFamily: "var(--cygreRegular), sans-serif",
          fontWeight: "500",
          fontSize: "14px",
        }}
      >
        {`${t("totalForWeek")} ${depositsArr?.length || 0}`}
      </Typography>
      <Typography
        sx={{
          color: "#2E263D",
          fontFamily: "var(--cygreRegular), sans-serif",
          fontWeight: "500",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        {`${t("totalAmount")} ${totalWeeklyDepositsAmount || 0.0}$`}
      </Typography>
      <Box
        sx={{
          padding: "16px 16px",
          borderRadius: "8px",
          boxShadow:
            "rgba(255, 255, 255, 0.5) 2px 2px 2px 0px inset, rgba(0, 0, 0, 0.1) 7px 7px 20px 0px, rgba(0, 0, 0, 0.1) 4px 4px 5px 0px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "var(--cygreRegular), sans-serif",
            fontWeight: "500",
            fontSize: "12px",
            textAlign: "center",
            color: "#2E263D",
            marginBottom: "8px",
          }}
        >
          {t("depositsForTheWeek")}
        </Typography>
        {depositsArr.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "230px",
              maxHeight: "230px",
            }}
          >
            <Typography
              sx={{
                display: "inline-block",
                maxWidth: "200px",
                fontFamily: "var(--cygreRegular), sans-serif",
                fontWeight: "400",
                fontSize: "12px",
                textAlign: "center",
                color: "#2E263D",
              }}
            >
              {t("emptyDepositsList")}
            </Typography>
          </Box>
        ) : (
          <List
            dense
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              padding: 0,
              minHeight: "230px",
              maxHeight: "230px",
              overflowY: "auto",
            }}
          >
            {depositsArr?.map((domain, index) => {
              const { userName, amount, date, _id } = domain;
              const domainExpiredAtDate = formatDateDDMMYYYY(date);

              return (
                <ListItem key={_id} disablePadding sx={{ alignItems: "baseline" }}>
                  <ListItemIcon sx={{ minWidth: "10px", fontSize: "12px", marginRight: "6px" }}>
                    {index + 1}.
                  </ListItemIcon>
                  <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <Typography
                      sx={{
                        fontFamily: "var(--cygreRegular), sans-serif",
                        fontWeight: "400",
                        fontSize: "12px",
                        textAlign: "center",
                        color: "#2E263D",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {userName}
                    </Typography>
                    <Box sx={{ display: "flex", gap: "16px" }}>
                      <Typography
                        sx={{
                          fontFamily: "var(--cygreRegular), sans-serif",
                          fontWeight: "400",
                          fontSize: "12px",
                          textAlign: "center",
                          color: "#56CA00",
                        }}
                      >
                        {`${amount}$`}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "var(--cygreRegular), sans-serif",
                          fontWeight: "400",
                          fontSize: "12px",
                          textAlign: "center",
                          color: "#2E263D",
                        }}
                      >
                        {domainExpiredAtDate}
                      </Typography>
                    </Box>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        )}
      </Box>
    </Grid>
  );
};

export default DepositStats;
